module.exports = __webpack_public_path__ + "media/images/emoticons/pc-710ae3897e47652e0bc7cc5692fde766.gif";